module.exports = __webpack_public_path__ + "static/media/faqImage4.aaca00ce.svg";